import { TEMPLATES } from "../actions/types";

const initialState = {
    error: null,
    data: {
        templates: {},
        metadata: {},
    },
    isLoading: false,
    selectedFilters: {
        TEMPLATE_FILTER_SEARCH: '',
        TEMPLATE_FILTER_USABILITY_TESTING_GOALS: [],
        TEMPLATE_FILTER_INDUSTRIES: [],
        TEMPLATE_FILTER_TAGS: [],
        TEMPLATE_FILTER_DEVICE_TYPES: [],
        TEMPLATE_FILTER_TEST_TYPES: [],
    }
};

const templatesReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case TEMPLATES.LOAD:
            return { ...initialState, selectedFilters: state?.selectedFilters, error: null, isLoading: false, ...payload };

        case TEMPLATES.UPDATE:
            return { ...state, isLoading: false, error: null, ...payload };

        case TEMPLATES.ERROR:
            return { ...state, isLoading: false, error: null, ...payload };

        case TEMPLATES.RESET:
            return initialState;

        case TEMPLATES.ADD_TEMPLATE:
            return { ...state, isLoading: false, error: null };

        case TEMPLATES.SET_SELECTED_FILTERS:
            const { filterType, filterValue } = payload;
            return {
                ...state, selectedFilters: {
                    ...state.selectedFilters,
                    [filterType]: filterValue
                }
            };

        default:
            return state;
    }
};

export default templatesReducer;
